import { useMemo } from 'react';
import styles from './NotificationBox.module.scss';

export interface NotificationMessage {
    type?: 'success' | 'error' | 'warn';
    title: string;
    message?: string;
    details?: string[];
}

interface NotificationProps {
    notification: NotificationMessage | null;
}

export const NotificationBox = ({ notification }: NotificationProps) => {
    const boxStyle = useMemo(() => {
        if (!notification?.type) return styles.box;
        if (notification.type === 'error') {
            return `${styles.box} ${styles['box--error']}`;
        }
        if (notification.type === 'warn') {
            return `${styles.box} ${styles['box--warn']}`;
        }
        return `${styles.box} ${styles['box--success']}`;
    }, [notification]);

    const titleStyle = useMemo(() => {
        if (!notification?.type) return styles.title;
        if (notification.type === 'error') {
            return `${styles.title} ${styles['title--error']}`;
        }
        if (notification.type === 'warn') {
            return `${styles.title} ${styles['title--warn']}`;
        }
        return `${styles.title} ${styles['title--success']}`;
    }, [notification]);

    const notificationIcon = useMemo(() => {
        if (!notification?.type) return null;
        if (notification.type === 'error') {
            return <span className="Appkit4-icon icon-error-fill"></span>;
        }
        if (notification.type === 'warn') {
            return <span className="Appkit4-icon icon-warning-fill"></span>;
        }
        return <span className="Appkit4-icon icon-circle-checkmark-fill"></span>;
    }, [notification]);

    if (!notification) {
        return null;
    }

    return (
        <>
            <div className={boxStyle}>
                <p className={titleStyle}>
                    {notificationIcon}
                    {notification.title}
                </p>
            </div>
            {notification.message && <p className={styles.message}>{notification.message}</p>}
            {notification.details && notification.details.length > 0 && (
                <ul className={styles.details}>
                    {notification.details.map((detail: string, idx: number) => (
                        <li key={idx} className={styles.detail}>
                            {detail}
                        </li>
                    ))}
                </ul>
            )}
        </>
    );
};

export default NotificationBox;
